export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS 2021.8f43fddb.pdf";